import BaseApi from 'Base/api/BaseApi';

class AllocationRoleApi extends BaseApi {
    static SCOPE = {
        CM: 'cm',
        RM: 'rm',
    };

    static PARAM = {
        ID: 'id',
        SCOPE: 'scope',
    };

    async getRoleDetails({ scope = AllocationRoleApi.SCOPE.RM }) {
        return this.axiosInstance.get(`${this.baseUrl}app/sysadm/${scope}/roles/details`);
    }

    async getRole({ id, scope = AllocationRoleApi.SCOPE.RM }) {
        return this.axiosInstance.get(`${this.baseUrl}app/sysadm/${scope}/roles/${id}`);
    }

    async deleteRole({ id, scope = AllocationRoleApi.SCOPE.RM }) {
        return this.axiosInstance.delete(`${this.baseUrl}app/sysadm/${scope}/roles/${id}`);
    }

    async updateRole({ data, scope = AllocationRoleApi.SCOPE.RM }) {
        const isUpdateRole = parseInt(data?.id) > 0;

        return this.axiosInstance({
            url: `${this.baseUrl}app/sysadm/${scope}/roles/${data.id || ''}`,
            method: isUpdateRole ? 'PUT' : 'POST',
            data,
        });
    }

    async getRoles({ scope = 'rm' }) {
        return this.axiosInstance.get(`${this.baseUrl}app/sysadm/${scope}/roles`);
    }
}

export default AllocationRoleApi;
